import React from 'react'

function Button({name, handleClick,className,style}) {
    
    const element = 
        <button 
            className={className}
            id={`${name}`} 
            style={style} 
            onClick={handleClick}
        >
            {name}
        </button>;
    
    return element;
}
  


export default Button